import React from 'react'
import { formatDate, renderPayload } from '../utils/helpers'

const HistoryList = ({ rows, exercise, topWeight, onDelete, fastestTime }) => {
  if (!rows.length) {
    return (
      <div style={{ 
        color: '#6c757d',
        textAlign: 'center',
        padding: '32px 20px',
        background: 'rgba(232, 119, 34, 0.05)',
        borderRadius: '12px',
        border: '2px dashed rgba(232, 119, 34, 0.2)',
        fontStyle: 'italic'
      }}>
        <div style={{ fontSize: '24px', marginBottom: '8px' }}>📊</div>
        <div style={{ fontWeight: '600', marginBottom: '4px' }}>No workout history yet</div>
        <div style={{ fontSize: '13px' }}>Your entries will appear here</div>
      </div>
    )
  }

  return (
    <div style={{ 
      background: 'rgba(255, 255, 255, 0.95)',
      border: '2px solid rgba(232, 119, 34, 0.1)',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
    }}>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, rgba(232, 119, 34, 0.1) 0%, rgba(232, 119, 34, 0.05) 100%)',
        padding: '12px 16px',
        borderBottom: '1px solid rgba(232, 119, 34, 0.1)',
        fontWeight: '700',
        fontSize: '13px',
        color: '#495057',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
      }}>
        📈 Workout History ({rows.length} {rows.length === 1 ? 'entry' : 'entries'})
      </div>
      {/* History Entries */}
      <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
        {rows.map((result, index) => {
          const isTop = (result.payload?.weight != null && Number(result.payload.weight) === Number(topWeight)) 
                       || (fastestTime && result.payload?.time === fastestTime)
          
          const handleDelete = () => {
            if (!confirm('Are you sure you want to delete this entry?')) return
            onDelete(result._id)
          }

          return (
            <div 
              key={result._id} 
              style={{ 
                color: '#212529', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between', 
                gap: 12,
                padding: '16px',
                borderBottom: index < rows.length - 1 ? '1px solid rgba(0,0,0,0.08)' : 'none',
                background: isTop ? 'linear-gradient(135deg, rgba(232, 119, 34, 0.08) 0%, rgba(232, 119, 34, 0.04) 100%)' : 'transparent',
                transition: 'all 0.2s ease',
                position: 'relative'
              }}
              onMouseEnter={(e) => {
                if (!isTop) {
                  e.target.style.background = 'rgba(0,0,0,0.02)'
                }
              }}
              onMouseLeave={(e) => {
                if (!isTop) {
                  e.target.style.background = 'transparent'
                }
              }}
            >
              {/* Top record indicator */}
              {isTop && (
                <div style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  bottom: 0,
                  width: '4px',
                  background: 'linear-gradient(180deg, var(--bfit-orange) 0%, #ff8f50 100%)',
                  borderRadius: '0 2px 2px 0'
                }} />
              )}
              
              <div style={{ flex: 1, paddingLeft: isTop ? '8px' : '0' }}>
                <div style={{ 
                  fontWeight: 700, 
                  display: 'flex', 
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '4px',
                  fontSize: '14px'
                }}>
                  <span style={{ color: '#495057' }}>{exercise?.name}</span>
                  {isTop && (
                    <span style={{
                      background: 'var(--bfit-orange)',
                      color: '#000',
                      padding: '2px 6px',
                      borderRadius: '12px',
                      fontSize: '10px',
                      fontWeight: '800',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}>
                      🏆 BEST
                    </span>
                  )}
                </div>
                <div style={{ 
                  color: '#212529',
                  fontWeight: '600',
                  fontSize: '15px',
                  marginBottom: '4px'
                }}>
                  {renderPayload(result.payload, exercise)}
                </div>
                <div style={{ 
                  color: '#6c757d',
                  fontSize: '12px',
                  fontWeight: '500'
                }}>
                  {formatDate(result.createdAt)}
                </div>
              </div>
              
              <button 
                style={{
                  background: 'rgba(220, 53, 69, 0.1)',
                  border: '1px solid rgba(220, 53, 69, 0.2)',
                  color: '#dc3545',
                  padding: '6px 8px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '12px',
                  fontWeight: '600',
                  transition: 'all 0.2s ease',
                  minWidth: '28px',
                  height: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                onClick={handleDelete} 
                title="Delete entry"
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(220, 53, 69, 0.15)'
                  e.target.style.borderColor = 'rgba(220, 53, 69, 0.3)'
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(220, 53, 69, 0.1)'
                  e.target.style.borderColor = 'rgba(220, 53, 69, 0.2)'
                }}
              >
                ×
              </button>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default HistoryList
